import { useEffect } from "react";

import ToastRequestHandler from "components/adhoc/toast-request-handler";
import ApplicationsSection from "../components/generic/applications-section";
import GoAiguaModal from "../components/generic/goaiguamodal";
import EditAppsModal from "../components/generic/edit-apps-modal.component";
import CreateAppsGroupsModalContent from "components/adhoc/create-apps-groups-modal";
import DeleteContainersModalContent from "components/adhoc/delete-containers-modal-content.component";

import { useTranslation } from "utils/hooks/use-translation.hook";
import { makeAppsContainersTabFunctions } from "utils/tabs/apps-containers-tab-functions";
import { useAppsContainerTabContext } from "storage/context/apps-container-tab-context";

const AppsContainersTab = () => {
    const translate = useTranslation();

    const context = useAppsContainerTabContext();
    const {
        containers,
        modalContent,
        allContentIsReady,
        errorList,
        success,
        editActive,
        removeAllData,
    } = context;

    const {
        handleCloseModal,
        handleOpenModal,
        loadContainersdata,
        checkHasGoAiguaContent,
        defineModalTitle,
        handleCloseCreateModal,
        openCreateGroupModal,
        openCreateSubGroupModal,
        addButtonShouldRender,
    } = makeAppsContainersTabFunctions(context);

    useEffect(() => {
        loadContainersdata();
    }, []);

    return (
        <main className="l-launcher-layout">
            <section className="l-launcher-layout__app-panel">
                {Object.entries(containers).map(([title, container]) => {
                    if (!editActive && !container.length) return null;

                    return (
                        <ApplicationsSection
                            isGoAigua={checkHasGoAiguaContent(container)}
                            sectionData={container}
                            handleOpenModal={handleOpenModal}
                            openCreateSubGroupModal={openCreateSubGroupModal}
                            title={title}
                            key={title}
                        />
                    );
                })}
            </section>

            {addButtonShouldRender() ? (
                <button
                    onClick={openCreateGroupModal}
                    className="l-launcher-layout__new-group-button"
                >
                    {translate("app.welcome.page.add_group")}
                </button>
            ) : null}

            <GoAiguaModal
                headerTitle={translate(defineModalTitle())}
                isOpen={modalContent !== null}
                setIsOpen={handleCloseModal}
            >
                {modalContent === "edit" && (
                    <EditAppsModal
                        closeModalfn={handleCloseModal}
                        updateData={loadContainersdata}
                    />
                )}

                {modalContent === "create" && (
                    <CreateAppsGroupsModalContent
                        closeModalFn={handleCloseCreateModal}
                    />
                )}

                {modalContent === "delete" && (
                    <DeleteContainersModalContent
                        closeModalFn={handleCloseCreateModal}
                        updateData={loadContainersdata}
                    />
                )}
            </GoAiguaModal>

            <ToastRequestHandler
                allContentIsReady={allContentIsReady}
                closeToast={removeAllData}
                errorList={errorList}
                success={success}
            />
        </main>
    );
};

export default AppsContainersTab;
